import { ADD_CLIENT, ADD_NOTICE, CLIENT_DATA, CLIENT_DETAILS, NOTICE_DATA, NOTICE_DETAILS } from "./ActionType";

const initialValue={
    addClient:[],
    clientDetails:[],
    clientDataById:[],
    addNotice:[],
    noticeDetails:[],
    noticeDataById:[],
}

export const configReducer=(store=initialValue, {type,payload})=>{

    if(type===ADD_CLIENT){
        return {
            ...store,addClient:  payload || [], 
        };
    }else if(type===CLIENT_DETAILS){
        return {
            ...store,clientDetails:  payload || [], 
        };
    }else if(type===CLIENT_DATA){
        return {
            ...store,clientDataById:  payload || [], 
        };
    }else if(type===ADD_NOTICE){
        return {
            ...store,addNotice:  payload || [], 
        };
    }else if(type===NOTICE_DETAILS){
        return {
            ...store,noticeDetails:  payload.noticeDtoList || [], 
        };
    }else if(type===NOTICE_DATA){
        return {
            ...store,noticeDataById:  payload || [], 
        };
    }

    return store
}